export default __webpack_public_path__ + "static/media/shieldofinfernalflames.ef28246c.png";